//
import Model from '@/models/Model'

/**
 * @description
 * This class describes a sl sale credit note.
 *
 * @class      SlSaleCreditNote (name)
 */
export default class SlSaleCreditNote extends Model {

  //
  static includes = [
    'sl_detail_sale_credit_notes',
    'sl_service_order.sl_sale_ticket_affected',
    'sl_service_order.sl_sale_invoice_affected',
  ]

  /**
   * @description
   * { function_description }
   *
   * @return     {string}  { description_of_the_return_value }
   */
  resource() {
    return 'sl_sale_credit_note'
  }

  /**
   * @description
   * { property_description }
   *
   * @type       {string}
   */
  get typeDocument(){
    if(this.sl_service_order) {
      if(this.sl_service_order.sl_sale_invoice_affected)
        return 'FACTURA ELECTRÓNICA'
      else if(this.sl_service_order.sl_sale_ticket_affected){
        return 'BOLETA ELECTRÓNICA'
      }      
    } else {
      return '-'
    }
  }

  /**
   * @description
   * { property_description }
   *
   * @type       {string}
   */
  get numberRerefence(){
    if (this.sl_service_order) {
        if(this.sl_service_order.sl_sale_invoice_affected)
            return this.sl_service_order.sl_sale_invoice_affected.number
        else if(this.sl_service_order.sl_sale_ticket_affected){
            return this.sl_service_order.sl_sale_ticket_affected.number
        }     
    } else {
        return '-'
    }
  }

  /**
   * Returns a pdf representation of the object.
   * @return     {Promise}  Pdf representation of the object.
   */
  toPdf = () => {
    return this
      .pdf()
      .then(this.mapPdf)
  }

  /**
   * { function_description }
   * @param      {<type>}  res     The resource
   * @return     {<type>}  { description_of_the_return_value }
   */
  mapPdf = res => {
    return this.showFile(this.file_name, 'pdf').call(this, res)
  }

  /**
   * The file name
   * @type       {string}
   */
  get file_name() {
    return `NOTA_CREDITO_${this.number}`
  }
}
